import React from 'react';
import {
    useHistory
  } from "react-router-dom";
  
  function ThankYou(props)  {

    
    const data = 
      {
      "id": 1,
      "name": "Favorite BBQ",
      "street": "123 Main St.",
      "city": "Sandy Springs",
      "state": "Georgia",
      "badges": 
      [        
        {
            "id": 1,
            "name": "I love Favorite BBQ",
            "price": 5,
            "logo": "",
            "selected": false
        },
        {
            "id": 2,
            "name": "Can't wait to get back to Favorite BBQ",
            "price": 5,
            "logo": "",
            "selected": false
        },
        {
            "id": 3,
            "name": "Favorite BBQ Super Fan!",
            "price": 20,
            "logo": "",
            "selected": false
        },

      ]
    }
    ;

     const selection =data.badges;
    
    const list = props.list;

    return <div className="App container">
            <h1>Thank you!</h1>
            <div className="row">
                <div class="col-12">You've shown your support for {data.name} of {data.city}, {data.state}</div>
            </div>
            <hr/>
            <div className="row">
                <div class="col-12">Here's your link for social media:</div>
            </div>
            <div className="row">
                <div class="col-12"><input type="text" value="http://locally.gives/s/asdfjadsifjasdf"/>[Copy]<br/><br/></div>
            </div>
            <div className="row">
                <div class="col-12"><img src="/soldbadge.png" alt="Thank you!"/></div>
            </div>
            <div className="row">
                <div class="col-12">
                    <p>The badge above is for you!</p>
                    <p>This QR Code will bring anyone back to this site showing your support</p>
                </div>
            </div>
            <div className="row">
                <div class="col-12">
                    <a href="/">Support Another Business</a>
                </div>
            </div>
        </div>
    ;
  }

 
  export default ThankYou;


